export const ru = {
    'all-campaigns': 'Все кампании',
    'all-groups': 'Все группы',
    'banners-max-selected':
        'Выберите до {maxCount} объявлений, чтобы их отредактировать',
    'banners-selected-all': 'Выбраны все объявления',
    'banners-selected-many-of-all': 'Выбрано {rowsCount} объявлений из {total}',
    'banners-selected-one-of-all': 'Выбрано {rowsCount} объявление из {total}',
    'banners-selected-some-of-all': 'Выбрано {rowsCount} объявления из {total}',
    'banners-tab-name': 'Объявления',
    'campaigns-selected-all': 'Выбраны все кампании',
    'campaigns-selected-many-of-all': 'Выбрано {rowsCount} кампаний из {total}',
    'campaigns-selected-one-of-all': 'Выбрана {rowsCount} кампания из {total}',
    'campaigns-selected-some-of-all': 'Выбрано {rowsCount} кампании из {total}',
    'campaigns-tab-name': 'Кампании',
    'edit-available-only-for-one-banner':
        'Редактировать можно не более одного баннера за раз',
    'edit-available-only-for-one-phrase':
        'Редактировать можно не более одной фразы за раз',
    'feed-filters-tab-name': 'Фильтры фидов',
    'groups-max-selected':
        'Выберите до {maxCount} групп, чтобы их отредактировать',
    'groups-selected-all': 'Выбраны все группы',
    'groups-selected-many-of-all': 'Выбрано {rowsCount} групп из {total}',
    'groups-selected-one-of-all': 'Выбрана {rowsCount} группа из {total}',
    'groups-selected-some-of-all': 'Выбрано {rowsCount} группы из {total}',
    'groups-tab-name': 'Группы',
    'out-of-selection-limit':
        'Доступно при выборе менее {selectionLimit} элементов',
    'phrases-selected-all': 'Выбраны все фразы',
    'phrases-selected-many-of-all': 'Выбраны {rowsCount} фраз из {total}',
    'phrases-selected-one-of-all': 'Выбрана {rowsCount} фраза из {total}',
    'phrases-selected-some-of-all': 'Выбраны {rowsCount} фразы из {total}',
    'phrases-tab-name': 'Фразы',
    'retargetings-tab-name': 'Ретаргетинг и аудитории',
    'search-and-replace-forbidden-for-relevance-match':
        'Поиск и замена невозможны для автотаргетинга',
    'select-campaigns': 'Выберите кампании',
    'selected-groups-must-belong-to-one-campaign':
        'Выбранные группы должны принадлежать одной кампании',
    'targetings-selected-all': 'Выбраны все условия показа',
    'targetings-selected-many-of-all':
        'Выбраны {rowsCount} условий показа из {total}',
    'targetings-selected-one-of-all':
        'Выбрано {rowsCount} условие показа из {total}',
    'targetings-selected-some-of-all':
        'Выбраны {rowsCount} условий показа из {total}',
    'targetings-tab-name': 'Условия показа',
    'there-are-non-editable-banner':
        'Выбрано объявление, недоступное для редактирования',
    'there-are-non-editable-group':
        'Выбраны группы недоступные для редактирования',
    'users-profile-tab-name': 'Профили пользователей'
};
